import { render } from "./CustomerIndex.vue?vue&type=template&id=47c39f84&ts=true"
import script from "./CustomerIndex.vue?vue&type=script&lang=ts"
export * from "./CustomerIndex.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__